import { acceptHMRUpdate, defineStore, createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
export const useConfigStore = defineStore(
  'config',
  () => {
    const currentPage = ref('')

    // set currentPage
    function setCurrentPage(name: any) {
      currentPage.value = name
    }

    return {
      currentPage,
      setCurrentPage
    }
  },
  {
    persist: false
  }
)

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useConfigStore, import.meta.hot))
